import { formatISO } from "date-fns";
import { z } from "zod";

export const transactionRuleReviewSchema = z.object({
    id: z.string().uuid(),
    ruleId: z.string().uuid(),
    userId: z.number(),
    ruleContentHash: z.string(),
    createdAt: z.coerce.date().transform((date) => formatISO(date)),
});

export const transactionRuleReviewerSchema = z.object({
    name: z.string(),
    email: z.string().nullable(),
    avatar: z.string().nullable(),
    iconColor: z.string(),
});
export type TransactionRuleReviewer = z.infer<
    typeof transactionRuleReviewerSchema
>;

export function toTransactionRuleReviewer({
    name,
    email,
    avatar,
    iconColor,
}: TransactionRuleReviewer): TransactionRuleReviewer {
    return { name, email, avatar, iconColor };
}

export const transactionRuleReviewWithReviewerSchema =
    transactionRuleReviewSchema.extend({
        reviewer: transactionRuleReviewerSchema,
    });
export type TransactionRuleReviewWithReviewer = z.output<
    typeof transactionRuleReviewWithReviewerSchema
>;

export const transactionRuleReviewPathParamsSchema = z.object({
    workspaceId: z.string().uuid(),
    ruleId: z.string().uuid(),
});

export const transactionRuleReviewsResponseSchema = z.object({
    currentRuleContentHash: z.string(),
    reviews: z.array(transactionRuleReviewSchema),
});

export const transactionRuleReviewResponseSchema = z.object({
    review: transactionRuleReviewSchema,
});

export const transactionRuleReviewRevokeResponseSchema = z.object({
    deleted: z.boolean(),
});
